<template>
    <Modal
        ref="modal"
        :id="modalId"
        :opened="isOpen"
        size="modal--full"
        :show-close-button="true"
        @close="onClose"
    >
        <div slot="content" class="todo-list-modal">
            <h2 class="font-h2">{{ labels.title }}</h2>

            <UnpaidInvoiceBanner
                v-if="unpaidInvoice"
                :message="labels.unpaidInvoice"
            />

            <p class="todo-list-modal__intro">{{ labels.intro }}</p>

            <div class="todo-list-modal__cards">
                <TodoStepCard
                    v-for="step in currentSteps"
                    :key="step.key"
                    :step="step"
                    :company-id="companyId"
                    :is-focused="focusStepKey === step.key"
                    :labels="cardLabels"
                    @acknowledged="onStepAcknowledged"
                />
            </div>
        </div>
    </Modal>
</template>

<script>
import Modal from '../layout/Modal.vue';
import TodoStepCard from './TodoStepCard.vue';
import UnpaidInvoiceBanner from './UnpaidInvoiceBanner.vue';

export default {
    name: 'TodoListModal',
    components: { Modal, TodoStepCard, UnpaidInvoiceBanner },
    props: {
        modalId: { type: String, default: 'todo-list-modal' },
        initialSteps: { type: Array, required: true },
        companyId: { type: Number, required: true },
        unpaidInvoice: { type: Boolean, default: false },
        autoReopen: { type: Boolean, default: false },
        focusStepKey: { type: String, default: null },
        // Translated labels — set of strings the wrapper Blade injects.
        // Expected: title, intro, unpaidInvoice + card labels under .card.
        labels: { type: Object, required: true },
    },
    data() {
        return {
            currentSteps: this.initialSteps.map(s => Object.assign({}, s)),
            isOpen: true,
        };
    },
    computed: {
        cardLabels() {
            return this.labels.card || {};
        },
    },
    mounted() {
        if (this.autoReopen && this.focusStepKey) {
            this.$nextTick(() => this.scrollToFocused());
        }
    },
    methods: {
        onClose() {
            this.isOpen = false;
        },
        onStepAcknowledged({ key, isComplete }) {
            const step = this.currentSteps.find(s => s.key === key);
            if (step) {
                step.acknowledged = true;
            }
            if (isComplete) {
                this.isOpen = false;
            } else {
                this.scrollToNextUnacknowledged();
            }
        },
        scrollToFocused() {
            const el = document.querySelector(`[data-step-key="${this.focusStepKey}"]`);
            if (el && el.scrollIntoView) {
                el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        },
        scrollToNextUnacknowledged() {
            const next = this.currentSteps.find(s => !s.acknowledged);
            if (!next) {
                return;
            }
            this.$nextTick(() => {
                const el = document.querySelector(`[data-step-key="${next.key}"]`);
                if (el && el.scrollIntoView) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            });
        },
    },
};
</script>
